import { render, staticRenderFns } from "./open-question.vue?vue&type=template&id=5c99659b&scoped=true"
import script from "./open-question.vue?vue&type=script&lang=js"
export * from "./open-question.vue?vue&type=script&lang=js"
import style0 from "./open-question.vue?vue&type=style&index=0&id=5c99659b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99659b",
  null
  
)

export default component.exports